<template>
	<div class="container">
		<div class="content">
			<div class="information">
				<p>
					{{
						$t('rtr_auth-dashboard.greeting_message', {
							user: $store.state.auth.member_info.user_name,
							date: $dayjs($store.state.auth.member_info.last_login).format(
								'YYYY.MM.DD HH:mm:ss',
							),
						})
					}}
				</p>
			</div>

			<div class="d_flex">
				<div class="flex_grow mr_10 w40">
					<div id="popularAssets" class="card">
						<h3 class="card_title">{{ $t('rtr_auth-dashboard.text1') }}</h3>
						<ul class="d_flex">
							<li
								class="asset_box w20 justify_center"
								v-for="(item, idx) in popularAssets"
								v-bind:key="idx"
							>
								<router-link
									:to="{
										name: 'wallet_account-assets',
										query: { assetSeq: item.seq },
									}"
									class="tac"
									><span v-bind:class="[item.code, 'large']"></span>
									<div>
										<p class="code mb_4">{{ item.code }}</p>
										<p class="name">{{ item.title }}</p>
									</div>
								</router-link>
							</li>
						</ul>
					</div>
					<div class="card favoriteAsset">
						<h3 class="card_title">{{ $t('rtr_auth-dashboard.text2') }}</h3>
						<ul class="d_flex" v-if="favoriteAssetList">
							<li
								class="asset_box w20 justify_center"
								v-for="(item, idx) in favoriteAssetList"
								v-bind:key="idx"
							>
								<router-link
									:to="{
										name: 'wallet_account-assets',
										query: { assetSeq: item.seq },
									}"
									class="tac"
									><span v-bind:class="[item.code, 'large']"></span>
									<div>
										<p class="code mb_4">{{ item.code }}</p>
										<p class="name">{{ item.title }}</p>
									</div>
								</router-link>
							</li>
						</ul>
						<router-link
							:to="{ name: 'wallet_account-assets' }"
							class="icon_position FAVORITES"
						></router-link>
					</div>
					<router-link :to="{ name: 'wallet_account-assets' }">
						<div id="banner" class="card type_banner wallet bg_green">
							<h3 class="card_title">{{ $t('banner1.text1') }}</h3>
							<p>
								{{ $t('banner1.text2') }}<br />
								{{ $t('banner1.text3') }}<br />
								{{ $t('banner1.text4') }}
							</p>
						</div>
					</router-link>

					<div class="d_flex link_area">
						<div class="flex_grow mr_10 w50">
							<router-link :to="{ name: 'pay-payment' }">
								<div id="send" class="card type_link send bg_black">
									<p class="fc_white">{{ $t('rtr_auth-dashboard.send') }}</p>
								</div>
							</router-link>
							<router-link :to="{ name: 'pay-deposit' }">
								<div id="request" class="card type_link request bg_red mb_0">
									<p class="fc_white">{{ $t('rtr_auth-dashboard.request') }}</p>
								</div>
							</router-link>
						</div>
						<div class="w50">
							<router-link :to="{ name: 'activity' }">
								<div id="history" class="card type_link history mb_0">
									<p>{{ $t('rtr_auth-dashboard.history') }}</p>
								</div>
							</router-link>
						</div>
					</div>
				</div>

				<div class="box_right w60" v-show="favoriteAccountList">
					<div
						class="card"
						v-for="(item, idx) in favoriteAccountList"
						v-bind:key="idx"
					>
						<div class="asset_box">
							<div v-bind:class="[item.asset_code, 'medium']"></div>
							<div>
								<p class="code mb_4">{{ item.asset_code }}</p>
								<p class="name">{{ item.asset_title }}</p>
							</div>
						</div>
						<div class="quantity">
							{{ $filters.formatCurrency(item.balance) }}
							<span class="currency">{{ item.asset_code }}</span>
						</div>
						<div class="tar">
							<button @click="toSend(item.seq)" class="black mr_5">
								{{ $t('button.send') }}
							</button>
							<button class="red" @click="toDeposit(item.seq)">
								{{ $t('button.request') }}
							</button>
						</div>
						<router-link
							:to="{
								name: 'activity',
								query: {
									asset_seq: item.asset_seq,
									account_seq: item.seq,
								},
							}"
							class="icon_position HISTORY"
						></router-link>
					</div>
					<router-link :to="{ name: 'wallet_account-assets' }">
						<div
							class="card bookmark mb_0"
							v-if="favoriteAccountList.length < 5"
						>
							<span id="bookmark" class="icon_add FAVORITES"></span>
							<p>{{ $t('rtr_auth-dashboard.text3') }}</p>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>

<script>
import { mapGetters } from 'vuex';
import Tutorial from '@/components/Tutorial';
import Cookies from 'js-cookie';

export default {
	name: 'Dashboard',
	components: { Tutorial },
	data() {
		return {
			favoriteAssetsSeq: [],
			favoriteAssetKey:
				'favoriteAsset_' + this.$store.state.auth.member_info.seq,
			tour: null,
			showTutorial: false,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('account', ['own_assets_group']),
		...mapGetters('assets', ['assets']),
		...mapGetters('auth', ['member_info']),
		own_assets_items() {
			let data = [];
			const group = Object.keys(this.own_assets_group).map(Number);
			this.assets.forEach(assetItem => {
				if (group.includes(assetItem.seq)) data.push(assetItem);
			});
			return data;
		},
		popularAssets() {
			return this.assets.slice(0, 5);
		},
		favoriteAssetList() {
			if (this.favoriteAssetsSeq.length === 0) {
				return this.own_assets_items.slice(0, 5);
			} else {
				return this.assets
					.filter(item => {
						const index = this.favoriteAssetsSeq.indexOf(item.seq);
						return index !== -1;
					})
					.slice(0, 5);
			}
		},
		favoriteAccountList() {
			let data = [];
			this.favoriteAssetList.forEach(assetItem => {
				this.accounts.forEach(accountItem => {
					if (data.length === 5) return;
					if (assetItem.seq === accountItem.asset_seq) data.push(accountItem);
				});
			});
			return data;
		},
	},
	mounted() {
		if (localStorage.getItem(this.favoriteAssetKey)) {
			this.favoriteAssetsSeq = JSON.parse(
				localStorage.getItem(this.favoriteAssetKey),
			);
		}
		this.tutorialHandler();
	},
	methods: {
		toSend(seq) {
			this.$router.push({
				name: 'pay-payment',
				query: { accountSeq: seq },
			});
		},
		toDeposit(seq) {
			this.$router.push({
				name: 'pay-deposit',
				query: { accountSeq: seq },
			});
		},
		tutorialHandler() {
			if (!Cookies.get(this.$route.name + '_tutorial')) {
				this.showTutorial = true;
			}
		},
	},
};
</script>
